var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookMarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.6C0 16.6392 0 12.1587 1.7439 8.73615C3.27787 5.72556 5.72556 3.27787 8.73615 1.7439C12.1587 0 16.6392 0 25.6 0H142.4C151.361 0 155.841 0 159.264 1.7439C162.274 3.27787 164.722 5.72556 166.256 8.73615C168 12.1587 168 16.6392 168 25.6V142.4C168 151.361 168 155.841 166.256 159.264C164.722 162.274 162.274 164.722 159.264 166.256C155.841 168 151.361 168 142.4 168H25.6C16.6392 168 12.1587 168 8.73615 166.256C5.72556 164.722 3.27787 162.274 1.7439 159.264C0 155.841 0 151.361 0 142.4V25.6Z",
    fill: "#0F0F37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73.9008C47 65.4184 47 61.1773 48.311 57.7449C50.9606 50.8079 57.3539 45.3692 65.5085 43.1152C69.5433 42 74.5289 42 84.5 42C94.4712 42 99.4567 42 103.492 43.1152C111.646 45.3692 118.039 50.8079 120.689 57.7449C122 61.1773 122 65.4184 122 73.9008V107.567C122 116.304 122 120.672 120.168 122.982C117.93 125.805 114.03 127.331 110.054 126.939C106.8 126.619 102.901 123.776 95.1034 118.09C91.671 115.588 89.9547 114.336 88.0695 113.769C85.7598 113.075 83.2402 113.075 80.9305 113.769C79.0453 114.336 77.329 115.588 73.8966 118.09C66.0987 123.776 62.1998 126.619 58.9457 126.939C54.9703 127.331 51.0699 125.805 48.8319 122.982C47 120.672 47 116.304 47 107.567V73.9008Z",
    stroke: "url(#paint0_linear_1_145196)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4365 73.458H98.5615",
    stroke: "url(#paint1_linear_1_145196)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73.9008C47 65.4184 47 61.1773 48.311 57.7449C50.9606 50.8079 57.3539 45.3692 65.5085 43.1152C69.5433 42 74.5289 42 84.5 42C94.4712 42 99.4567 42 103.492 43.1152C111.646 45.3692 118.039 50.8079 120.689 57.7449C122 61.1773 122 65.4184 122 73.9008V107.567C122 116.304 122 120.672 120.168 122.982C117.93 125.805 114.03 127.331 110.054 126.939C106.8 126.619 102.901 123.776 95.1034 118.09C91.671 115.588 89.9547 114.336 88.0695 113.769C85.7598 113.075 83.2402 113.075 80.9305 113.769C79.0453 114.336 77.329 115.588 73.8966 118.09C66.0987 123.776 62.1998 126.619 58.9457 126.939C54.9703 127.331 51.0699 125.805 48.8319 122.982C47 120.672 47 116.304 47 107.567V73.9008Z",
    stroke: "white",
    strokeWidth: 2.37736,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4365 73.458H98.5615",
    stroke: "white",
    strokeWidth: 2.37736,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_145196",
    x1: 138.339,
    y1: 146.024,
    x2: 21.7806,
    y2: 147.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5194D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_145196",
    x1: 177.416,
    y1: 96.6783,
    x2: 85.3361,
    y2: 144.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5194D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookMarkIcon);
export default __webpack_public_path__ + "static/media/BookMarkIcon.054e323b385f6f3fc3c1a9b6d5aaaca0.svg";
export { ForwardRef as ReactComponent };